import React from 'react';
import styles from './ReportHistoryPanel.module.scss';
import { SFButton, SFDrawer, SFIconButton } from 'sfui';
import { MediaContext } from 'ui-smartforce-settings';

export interface ReportHistoryPanelProps {
  isOpen: boolean;
  isLoading?: boolean;
  isSaveButtonDisabled?: boolean;
  children: React.ReactNode;
  onClose: () => void;
  onBack?: () => void;
  onSave?: () => void;
}

export const ReportHistoryPanel = ({
  isOpen,
  isLoading,
  isSaveButtonDisabled,
  children,
  onClose,
  onBack,
  onSave
}: ReportHistoryPanelProps): React.ReactElement<ReportHistoryPanelProps> => {
  const { isPhone } = React.useContext(MediaContext);

  return (
    <SFDrawer
      PaperProps={{ className: styles.reportHistoryPanel }}
      open={isOpen}
      anchor={isPhone ? 'bottom' : 'right'}
      onClose={onClose}
    >
      <header>
        <SFIconButton sfIcon="Close" sfSize="medium" onClick={onClose} />
        {onBack && (
          <SFIconButton sfIcon="Left-7" sfSize="medium" onClick={onBack} />
        )}
      </header>

      {children}

      {onSave && (
        <footer>
          <SFButton
            size="large"
            variant="contained"
            sfColor="blue"
            fullWidth
            onClick={onSave}
            isLoading={isLoading}
            disabled={isSaveButtonDisabled}
          >
            Save Changes
          </SFButton>
        </footer>
      )}
    </SFDrawer>
  );
};
